export default __webpack_public_path__ + "static/media/post-suvinil2.b69648a9.png";